import { SelectedSlotsState } from '../../../../../../calendar/tabs/serial/components/time-slots/types/selected-slots';
import { LecturerIdWithActivityTypeId } from '../../../../../../calendar/tabs/serial/create-lecture-serial-tab';
import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { ExamSessionDetails } from '../../../../../../../api/types/programs/course/exams/response/exam-metadata';

export const addExamClassesOperations = async (
  currentProgramId: number | undefined,
  currentCourseId: number | undefined,
  examId: number,
  examSessionId: number,
  selectedSlotsState: SelectedSlotsState,
  lecturesIdsWithActivityTypeId: LecturerIdWithActivityTypeId[],
  setIsLoadingCreateLectures: (loading: boolean) => any,
  setExamDetails: (sessions: ExamSessionDetails[]) => any,
  onHide: () => any,
) => {
  try {
    if (!currentProgramId || !currentCourseId) {
      toast.warn('לא ניתן לאתר את מזהה התוכנית ו/או הקורס');
      return;
    }

    const schedules = Object.values(selectedSlotsState)
      .flat()
      .map((item) => ({
        startTime: item.startTime,
        endTime: item.endTime,
        classId: item.classId,
      }));
    setIsLoadingCreateLectures(true);
    const res = await appApi.addExamClasses(
      currentProgramId,
      currentCourseId,
      examId,
      examSessionId,
      schedules,
    );

    setExamDetails(res.data.body);
    toast.success('הפעולה בוצעה בהצלחה');
    setIsLoadingCreateLectures(false);
    onHide();
  } catch (e) {
    console.error(
      `addExamClassesOperations is failed with the currentProgramId: ${currentProgramId}, currentCourseId: ${currentCourseId}, selectedSlotsState: ${selectedSlotsState} and the error: ${e}`,
    );
    setIsLoadingCreateLectures(false);
    toast.error('הפעולה נכשלה, נשה שוב בעוד מספר רגעים');
  }
};
